import React from 'react';
import { snakeCase } from 'lodash-es';
import classNames from 'classnames';
import { TwainGameId } from 'betgames-contract-js';
import { translationProvider } from 'twain-sport-fe-mono/store/translations';
import { ILeftVsRight, IStatistics, IStatisticsPair } from 'twain-sport-fe-mono/interfaces';
import { GridValue } from './GridValue';
import classes from './Grid.module.scss';

interface IProps {
    statistics: IStatisticsPair;
    short?: boolean;
    rowsAmount?: number;
    className?: string;
    gameId?: TwainGameId;
}

export const Grid: React.FC<IProps> = (props) => {
    const notEmptyStatistics: keyof ILeftVsRight<IStatistics[]> = props.statistics.left?.length
        ? 'left'
        : 'right';
    const gridLength = props.rowsAmount ?? props.statistics[notEmptyStatistics]?.length;

    return (
        <div
            className={classNames(classes.grid, { [classes.short]: props.short }, props.className)}
        >
            {new Array(gridLength).fill(null).map((_, index) => (
                <React.Fragment key={props.statistics[notEmptyStatistics][index].name}>
                    <GridValue value={props.statistics.left[index]} align="left" />
                    <div className={classes.separator} />
                    <div className={classes.title}>
                        {translationProvider.stringByGame(
                            snakeCase(props.statistics[notEmptyStatistics][index].name),
                            props.gameId,
                        )}
                    </div>
                    <div className={classes.separator} />
                    <GridValue value={props.statistics.right[index]} align="right" />
                </React.Fragment>
            ))}
        </div>
    );
};
